import React from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { Mail, Linkedin, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
interface PartnerWithUsProps {
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
}
export const PartnerWithUs = ({
  openRegistrationForm,
  openHostSalonForm
}: PartnerWithUsProps) => {
  return <div className="pt-20" data-id="element-3533">
      <section className="py-16 bg-secondary/5" data-id="element-3534">
        <div className="container mx-auto px-4" data-id="element-3535">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-3536">
            Partner With Us
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-3537">
            Join forces with The Networking Salon to create meaningful
            connections, share resources, and build a stronger community
            together.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-3538">
        <div className="container mx-auto px-4" data-id="element-3539">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-3540">
            <div data-id="element-3541">
              <h2 className="text-3xl font-bold text-secondary-dark mb-6" data-id="element-3542">
                Why Partner With Us?
              </h2>
              <div className="space-y-4" data-id="element-3543">
                <p className="text-secondary" data-id="element-3544">
                  The Networking Salon brings together ambitious professionals,
                  entrepreneurs, and changemakers across 30+ cities worldwide.
                  Our community is built on authentic connections, resource
                  sharing, and creating opportunities.
                </p>
                <p className="text-secondary" data-id="element-3545">
                  By partnering with us, your organization gains access to a
                  diverse network of engaged individuals who are actively
                  seeking to grow, collaborate, and make an impact in their
                  fields.
                </p>
                <p className="text-secondary" data-id="element-3546">
                  We believe in creating partnerships that provide mutual value
                  and align with our mission of connecting young leaders to
                  networks, ideas, and opportunities worldwide.
                </p>
              </div>
            </div>
            <div data-id="element-3547">
              <Card className="p-0 overflow-hidden" data-id="element-3548">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg" alt="The Networking Salon event" className="w-full h-64 object-cover" data-id="element-3549" />
              </Card>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-3550">
            <Card className="flex flex-col items-center text-center p-8" data-id="element-3551">
              <div className="w-16 h-16 flex items-center justify-center bg-secondary/10 rounded-full mb-4" data-id="element-3552">
                <div className="w-8 h-8 border-2 border-secondary rounded-full" data-id="element-3553"></div>
              </div>
              <h3 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-3554">
                Event Collaborations
              </h3>
              <p className="text-secondary" data-id="element-3555">
                Co-create workshops, panels, and networking events that bring
                value to both our communities.
              </p>
            </Card>
            <Card className="flex flex-col items-center text-center p-8" data-id="element-3556">
              <div className="w-16 h-16 flex items-center justify-center bg-secondary/10 rounded-full mb-4" data-id="element-3557">
                <div className="w-8 h-8 border-2 border-secondary rounded-full" data-id="element-3558"></div>
              </div>
              <h3 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-3559">
                Resource Sharing
              </h3>
              <p className="text-secondary" data-id="element-3560">
                Exchange knowledge, tools, and platforms to support each other's
                growth and impact.
              </p>
            </Card>
            <Card className="flex flex-col items-center text-center p-8" data-id="element-3561">
              <div className="w-16 h-16 flex items-center justify-center bg-secondary/10 rounded-full mb-4" data-id="element-3562">
                <div className="w-8 h-8 border-2 border-secondary rounded-full" data-id="element-3563"></div>
              </div>
              <h3 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-3564">
                Community Connections
              </h3>
              <p className="text-secondary" data-id="element-3565">
                Access our network of professionals and help your audience find
                valuable connections.
              </p>
            </Card>
          </div>
          <div className="bg-secondary/5 rounded-lg p-8 border border-gray-200 mb-16" data-id="element-3566">
            <h2 className="text-2xl font-bold text-secondary-dark mb-6 text-center" data-id="element-3567">
              Get In Touch
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-3568">
              <Card className="flex flex-col items-center text-center p-6" data-id="element-3569">
                <Mail size={32} className="mb-4 text-secondary" data-id="element-3570" />
                <h3 className="text-lg font-bold text-secondary-dark mb-2" data-id="element-3571">
                  Email Us
                </h3>
                <p className="text-secondary mb-4" data-id="element-3572">
                  Send us a message to discuss partnership opportunities.
                </p>
                <a href="mailto:partner@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-3573">
                  partner@thenetworkingsalon.live
                </a>
              </Card>
              <Card className="flex flex-col items-center text-center p-6" data-id="element-3574">
                <Instagram size={32} className="mb-4 text-secondary" data-id="element-3575" />
                <h3 className="text-lg font-bold text-secondary-dark mb-2" data-id="element-3576">
                  Instagram
                </h3>
                <p className="text-secondary mb-4" data-id="element-3577">
                  Follow us for updates and direct message us.
                </p>
                <a href="https://www.instagram.com/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline" data-id="element-3578">
                  @thenetworkingsalon
                </a>
              </Card>
              <Card className="flex flex-col items-center text-center p-6" data-id="element-3579">
                <Linkedin size={32} className="mb-4 text-secondary" data-id="element-3580" />
                <h3 className="text-lg font-bold text-secondary-dark mb-2" data-id="element-3581">
                  LinkedIn
                </h3>
                <p className="text-secondary mb-4" data-id="element-3582">
                  Connect with us professionally and explore our content.
                </p>
                <a href="https://www.linkedin.com/showcase/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline" data-id="element-3583">
                  The Networking Salon
                </a>
              </Card>
            </div>
          </div>
          <div className="text-center" data-id="element-3584">
            <h2 className="text-2xl font-bold text-secondary-dark mb-6" data-id="element-3585">
              Join Our Community
            </h2>
            <p className="text-secondary mb-8 max-w-2xl mx-auto" data-id="element-3586">
              Want to be part of The Networking Salon? Join as a member or host
              a salon in your city.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-3587">
              <Link to="/joinnow" data-id="element-3588">
                <Button data-id="element-3589">Join a Salon</Button>
              </Link>
              <Button variant="outline" onClick={openHostSalonForm} data-id="element-3590">
                Host a Salon
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>;
};